export const ACTOR_TYPE = 'Actor';
export const ROLE_TYPE = 'Role';
export const BOUNDARY_TYPE = 'Boundary';
export const ACTION_TYPE = 'Action';
export const USECASE_TYPE = 'Usecase';
export const GOAL_TYPE = 'Goal';
